// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchInput_wrapper__4cG9w","input":"SearchInput_input__1vNm9","icon":"SearchInput_icon__1zOKV","errorMessage":"SearchInput_errorMessage__2O8W0"};